import {
    Modal,
    ModalHeader,
    ModalBody,
    Container,
    Col,
    Row,
} from 'reactstrap';
import EditPracticeRelationsForm from '../Forms/EditPracticeRelationsForm';

const EditPracticeRelationsModal = (props) => {
    const { isOpen, toggle: toggleModal, practiceId, relation } = props;
    
    let isEdit = relation ? true : false;

    const heading = `${isEdit ? 'Edit' : 'Add'} Offering`;

    const closeModal = () => toggleModal(false);

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => isOpen && closeModal}
            className="modal-md text-light"
            contentClassName="bg-secondary"
            centered={true}
            style={{ minWidth: '30vw' }}>
            <ModalHeader className="d-inline-block w-100 h-100">
                <Row>
                    <Col lg={8} sm="6" className="d-inline-block w-100 h-100">
                        <h4>{heading}</h4>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <Container>
                    <EditPracticeRelationsForm
                        isEdit={isEdit}
                        practiceId={practiceId}
                        selectedOffering={relation}
                        submitCB={closeModal}
                        closeCB={closeModal}
                    />
                </Container>
            </ModalBody>
        </Modal>
    );
};

export default EditPracticeRelationsModal;
